(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.overview
  (:require
   [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.overview.big-figures.view :refer [overview-figures-card]]
   [frontend.ui.component.lp-portal.report.overview.recent-development-figures.view :as recent-dev]
   [frontend.ui.component.lp-portal.section.view :refer [section]]))

(defn overview-section
  [{:keys [overview-figures
           recent-development-text
           highlights
           historical-net-cash-flows-to-investors
           total-investment
           net-asset-value 
           sector-allocation-nav 
           sector-allocation-gav
           country-allocation-nav
           country-allocation-gav]} props]
  (let [edit-mode? (:edit-mode? props)]
    [section
     "Overview"
     (str "overview-"
          (some->> props
                   :report
                   :db/id))
     [:div
      [overview-figures-card overview-figures props]
      [recent-dev/recent-development-with-highlights-card recent-development-text highlights
       (assoc props :title "Fund Figures (IFRS)")]
      [chart-card/row-view "Historical net cash flows to investors"
       historical-net-cash-flows-to-investors props]
      [grid/row {}
       [grid/column {:span 6}
        [chart-card/view "Current equity at cost" total-investment props]]
       [grid/column {:span 6}
        [chart-card/view "Net asset value" net-asset-value props]]]
      [grid/row {}
       [grid/column {:span 6}
        (when (or edit-mode? (:figures sector-allocation-nav))
              [chart-card/view "Sector allocation, NAV" sector-allocation-nav props])]
       [grid/column {:span 6}
        (when (or edit-mode?(:figures sector-allocation-gav))
          [chart-card/view "Sector allocation, GAV" sector-allocation-gav props])]]
      [grid/row {}
       [grid/column {:span 6}
        (when (or edit-mode? (:figures country-allocation-nav))
          [chart-card/view "Country allocation, NAV" country-allocation-nav props])]
       [grid/column {:span 6}
        (when (or edit-mode? (:figures country-allocation-gav))
          [chart-card/view "Country allocation, GAV" country-allocation-gav props])]]]]))
